<template>
  <div id="deliveryConfirm" v-if="isViewer">
    <dd-header
      :isMenuView='false'
    />
    <dd-sitemap
      :pageKey="pageKey"
      :pageList="orderForm.pageList"
    />
    <div class="container">
      <div id="content">
        <div class="title">
          <h2>ご注文内容確認</h2>
        </div>
        <dd-item-confirm
          v-for="(itemData,index) in nowList"
          :key="'cart-item-confirm-' + index"
          :itemData="itemData"
          :index="index+Number(1)"
          @onShowEstimateModal="onShowEstimateModal"
        />
        <section id="totalPrice">
          <h3 class="bold">注文情報</h3>
          <div class="input_list">
            <ul>
              <li>
                <table class="order_price_table">
                  <thead>
                    <tr>
                      <th>項目</th>
                      <th>単価</th>
                      <th>金額</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="b_separator">
                      <td>商品・配送料小計</td>
                      <td></td>
                      <td>{{formatPrice(cartData.cartModel.orderPrice.itemSubTotalPrice)}}</td>
                    </tr>
                    <tr>
                      <td>消費税</td>
                      <td>10%</td>
                      <td>{{formatPrice(cartData.cartModel.orderPrice.itemSubTotalTax)}}</td>
                    </tr>
                    <tr class="n_separator">
                      <td>商品・配送費合計</td>
                      <td></td>
                      <td>{{formatPrice(cartData.cartModel.orderPrice.itemTotalPrice)}}</td>
                    </tr>
                  </tbody>
                </table>
                <table class="order_price_table" style="margin-top: 20px">
                  <tbody>
                    <template v-if="isConstruct">
                      <tr class="b_separator tbl_space">
                        <td>組立設置他サービス費小計</td>
                        <td></td>
                        <td>{{formatPrice(cartData.cartModel.orderPrice.optSubTotalPrice)}}</td>
                      </tr>
                      <tr v-if="cartData.cartModel.orderPrice.discntPrice">
                        <td>諸経費割引</td>
                        <td></td>
                        <td>(-{{formatPrice(cartData.cartModel.orderPrice.discntPrice)}})</td>
                      </tr>
                      <tr class="n_separator" v-if="cartData.cartModel.orderPrice.discntPrice">
                        <td>割引後小計</td>
                        <td></td>
                        <td>{{formatPrice(cartData.cartModel.orderPrice.discntSubTotalPrice)}}</td>
                      </tr>
                      <tr>
                        <td>消費税</td>
                        <td>10%</td>
                        <td>{{formatPrice(cartData.cartModel.orderPrice.optTotalTax)}}</td>
                      </tr>
                      <tr class="n_separator">
                        <td>組立設置他サービス費合計</td>
                        <td></td>
                        <td>{{formatPrice(cartData.cartModel.orderPrice.optTotalPrice)}}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <table class="order_price_table" style="margin-top: 20px">
                  <tbody>
                    <template>
                      <tr class="b_separator">
                        <td>ご請求額合計</td>
                        <td></td>
                        <td>{{formatPrice(cartData.cartModel.orderPrice.totalPrice)}}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </li>
            </ul>
          </div>
        </section>
        <section id="person" v-if="orderForm.person && Object.keys(orderForm.person).length > 0">
          <h3 class="text_size_big bold">担当者情報</h3>
          <div class="input_confirm3">
            <ul>
              <li>
                <span>店舗名：</span>
                <span>{{orderForm.person.cofficeName}}</span>
              </li>
              <li>
                <span>担当者名：</span>
                <span>{{orderForm.person.userData.cuserLastName}} {{orderForm.person.userData.cuserFirstName}}</span>
              </li>
            </ul>
          </div>
        </section>
        <section id="owner">
          <h3 class="text_size_big bold">発注者情報</h3>
          <div class="input_confirm3" v-if="!isGuestUser">
            <ul>
              <li>
                <span>発注者企業名：</span>
                <span>{{userData.corpName}}</span>
              </li>
              <li>
                <span>郵便番号：</span>
                <span>{{userData.postcd}}</span>
              </li>
              <li>
                <span>発注者住所：</span>
                <span>{{userData.state}} {{userData.city}}</span>
              </li>
              <li>
                <span>以下、住所：</span>
                <span>{{userData.street}}</span>
              </li>
              <li>
                <span>発注者氏名：</span>
                <span>{{userData.userLastName}} {{userData.userFirstName}}</span>
              </li>
              <li>
                <span>（カナ）：</span>
                <span>{{userData.userLastNameKana}} {{userData.userFirstNameKana}}</span>
              </li>
              <li>
                <span>電話番号：</span>
                <span>{{userData.tel}}</span>
              </li>
            </ul>
          </div>
          <div class="input_confirm3" v-else>
            <ul>
              <li>
                <span>発注者氏名：</span>
                <span>{{userData.userLastName}} {{userData.userFirstName}}</span>
              </li>
              <li>
                <span>（カナ）：</span>
                <span>{{userData.userLastNameKana}} {{userData.userFirstNameKana}}</span>
              </li>
              <li>
                <span>電話番号：</span>
                <span>{{userData.tel}}</span>
              </li>
              <li>
                <span>メールアドレス：</span>
                <span>{{userData.email}}</span>
              </li>
            </ul>
          </div>
        </section>
        <section id="delivery">
          <h3 class="text_size_big bold">納品先情報</h3>
          <div class="input_confirm3">
            <ul>
              <li>
                <span>施主名(物件名)：</span>
                <span>{{deliveryData.businessName}}</span>
              </li>
              <li>
                <span>納品先名：</span>
                <span>{{deliveryData.building}}</span>
              </li>
              <li>
                <span>郵便番号：</span>
                <span>{{deliveryData.postcd}}</span>
              </li>
              <li>
                <span>納品先住所：</span>
                <span>{{deliveryData.state}} {{deliveryData.city}}</span>
              </li>
              <li>
                <span>以下、住所：</span>
                <span>{{deliveryData.street}}</span>
              </li>
              <li>
                <span>受取人氏名：</span>
                <span>{{deliveryData.userLastName}} {{deliveryData.userFirstName}}</span>
              </li>
              <li>
                <span>（カナ）：</span>
                <span>{{deliveryData.userLastNameKana}} {{deliveryData.userFirstNameKana}}</span>
              </li>
              <li>
                <span>電話番号：</span>
                <span>{{deliveryData.tel}}</span>
              </li>
              <li>
                <span>納品希望日： </span>
                <span>{{getViewDate(deliveryData.deliveryDate)}} {{getViewTime()}}</span>
              </li>
              <li>
                <span>配送時の連絡事項：</span>
                <span>{{deliveryData.message}}</span>
              </li>
            </ul>
          </div>
        </section>
        <section id="struct" v-if="orderForm.workFlag">
          <h3 class="text_size_big bold">組立設置情報</h3>
          <div class="input_confirm3">
            <ul>
              <li v-if="structData.businessName">
                <span>施主名(物件名)：</span>
                <span>{{structData.businessName}}</span>
              </li>
              <li>
                <span>郵便番号：</span>
                <span>{{structData.postcd}}</span>
              </li>
              <li>
                <span>設置先住所：</span>
                <span>{{structData.state}}{{structData.city}}</span>
              </li>
              <li>
                <span>以下、住所：</span>
                <span>{{structData.street}}</span>
              </li>
              <li>
                <span>立会人氏名：</span>
                <span>{{structData.userLastName}} {{structData.userFirstName}}</span>
              </li>
              <li>
                <span>（カナ）：</span>
                <span>{{structData.userLastNameKana}} {{structData.userFirstNameKana}}</span>
              </li>
              <li>
                <span>立会人電話番号：</span>
                <span>{{structData.tel}}</span>
              </li>
              <li>
                <span>第一作業希望日：</span>
                <span>{{getViewDate(structData.desiredDate1st)}}</span>
              </li>
              <li>
                <span>第二作業希望日：</span>
                <span>{{getViewDate(structData.desiredDate2nd)}}</span>
              </li>
              <li>
                <span>第三作業希望日：</span>
                <span>{{getViewDate(structData.desiredDate3rd)}}</span>
              </li>
              <li>
                <span>ご自宅のタイプ：</span>
                <span>{{homeType}}</span>
              </li>
              <li>
                <span>駐車場の有無：</span>
                <span>{{parkingSpace}}</span>
              </li>
              <li>
                <span>組立設置の連絡事項：</span>
                <span>{{structData.message}}</span>
              </li>
            </ul>
          </div>
        </section>
        <section v-if="!isPaygentSkip && !userData.isAccountPay">
          <h3 class="text_size_big bold">注意事項</h3>
          <dd-payment-caution />
        </section>
        <section id="deli_confirm">
          <h3 class="text_size_big bold">確認事項</h3>
          <div class="input_list">
            <div class="check_box">
              <input type="checkbox" id="confirmUseRule" v-model="confirmUseRule"/>
              <label for="confirmUseRule"><a class="link"><router-link class="link" to="/user/use-rule" target="_blank">利用規約</router-link></a>に同意して、購入する。</label>
            </div>
            <div class="check_box">
              <input type="checkbox" id="confirmItem" v-model="confirmItem"/>
              <label for="confirmItem">商品仕様を確認しました。</label>
            </div>
            <div class="check_box">
              <input type="checkbox" id="confirmOrderCancel" v-model="confirmOrderCancel"/>
              <label for="confirmOrderCancel" class="emphasis">オーダー家具のため、注文後のキャンセル及び仕様変更はできません。</label>
            </div>
            <div class="check_box">
              <input type="checkbox" id="confirmOrderDeliCancel" v-model="confirmOrderDeliCancel"/>
              <label for="confirmOrderDeliCancel" class="emphasis">注文後の納品日及び納品先の変更はできません。</label>
            </div>
          </div>
        </section>
        <section v-if="mkid===1">
          <h3 class="text_size_big bold">配送時の確認事項</h3>
          <div class="input_list confirmDeliArea">
            <div>
              ■ 集合住宅や店舗などの場合<br/>
              エレベーターがある場合 : 玄関前渡し<br/>
              エレベーターが無い場合 : 共有部エントランス前渡し<br/>
              <br/>
              ■ 戸建の場合<br/>
              玄関前渡し<br/>
              <br/>
              いずれの場合も原則置き便は出来ません。受取人様をご指定ください。<br/>
            </div>
            <div class="check_box">
              <input type="checkbox" id="confirmDelivery" v-model="confirmDelivery"/>
              <label for="confirmDelivery" class="emphasis">配送時の注意事項を確認しました。</label>
            </div>
          </div>
        </section>
        <section id="form_button">
          <div class="control_btn_area">
            <div class="detail_btn2" @click="reEdit">〈〈&nbsp;&nbsp;&nbsp;戻る&nbsp;&nbsp;&nbsp;</div>
            <div :class="{detail_btn: true, disabled: isOrderDisable}" @click="payment">
              {{payTypeLabel}}
            </div>
          </div>
        </section>
        <!-- <form name="ecform" :action="ecsiteUrl" method="post" :accept-charset="chatset">
          <div>
            <input type="hidden" v-for="[key, val] of Object.entries(ecData)" :key="'paygent_req_' + key" :name="key" v-bind:value="val"/>
          </div>
        </form> -->
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
// import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY, DC_PAYGENT_SKIP_ON} from '../../constants/App'
import {HOME_TYPE} from '../constants/TypeEc'
import * as FormUtil from '../../utils/FormUtil'
// Module
import Header from '../components/common/DcHeader'
import SiteMap from '../components/common/DcSiteMap'
import ItemConfirm from '../components/order/DcItemConfirm'
import PaymentCaution from '../components/order/DcPaymentCaution'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'OrderConfirm',
  components: {
    'dd-header': Header,
    'dd-sitemap': SiteMap,
    'dd-item-confirm': ItemConfirm,
    'dd-loading-modal': LoadingModal,
    'dd-payment-caution': PaymentCaution
  },
  data () {
    return {
      pageKey: 'orderConfirm',
      // 決済データ
      ecData: {},
      // 確認項目
      confirmItem: '',
      confirmOrderCancel: '',
      confirmOrderDeliCancel: '',
      confirmUseRule: '',
      confirmDelivery: '',
      // TOP画面入力項目
      topForm: {},
      orderForm: {},
      // userData: {},
      orderData: {},
      deliveryData: {},
      structData: {},
      errorMessage: { text: '' },
      validateErrorMessages: {},
      // 納品先ID
      submitDisable: false,
      ecsiteUrl: '',
      // 総額
      paymentFlag: false,
      isViewer: true,
      paymentType: undefined,
      chatset: 'UTF-8'
      // ecsiteUrl: 'https://sandbox.paygent.co.jp/v/u/request'
    }
  },
  computed: {
    ...mapState({
      cartData: state => state.cartData
    }),
    nowList: function () {
      if (!this.cartData || !this.cartData.cartModel || Object.keys(this.cartData.cartModel.orderList).length <= 0) return {}
      return this.cartData.cartModel.orderList
    },
    isOrderDisable: function () {
      if (!this.confirmItem || !this.confirmOrderCancel || !this.confirmUseRule || !this.confirmOrderDeliCancel) {
        return true
      }
      if (this.mkid === 1 && !this.confirmDelivery) {
        return true
      }
      return false
    },
    homeType: function () {
      return Object.keys(HOME_TYPE)
        .map(e => HOME_TYPE[e])
        .find(e => e.code === this.structData.homeType)
        .label
    },
    parkingSpace: function () {
      return FormUtil.getOnOff(this.structData.parkingSpace)
    },
    isPaygentSkip: function () {
      return DC_PAYGENT_SKIP_ON === 1
    },
    payTypeLabel: function () {
      if (this.isPaygentSkip || this.userData.isAccountPay) {
        return '注文の確定 〉〉'
      } else {
        return '決済へ進む 〉〉'
      }
    },
    businessName: function () {
      if (this.structData && this.structData.businessName) {
        return this.structData.businessName
      }
      return this.deliveryData.businessName
    },
    building: function () {
      if (this.structData && this.structData.building) {
        return this.structData.building
      }
      return this.deliveryData.building
    },
    isConstruct: function () {
      if (!this.nowList) return false
      return this.nowList.some(c => c.planEc.ecInfoOpExFlag === true)
    },
    userData: function () {
      let userData = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
      if (!userData || userData.userLevel === 4) {
        userData = App.getLocalStorage(DC_STORAGE_KEY.GUEST_USER_INFO)
      }
      return userData
    },
    isGuestUser: function () {
      if (!this.userInfo || this.userInfo.userLevel === 4) {
        return true
      }
      return false
    },
    mkid: function () {
      if (this.orderForm.corpId === 27) return 1
      if (this.orderForm.corpId === 1070) return 2
      return 0
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    reEdit: function () {
      this.$router.go(-1)
    },
    payment: function () {
      if (this.paymentFlag) return
      this.paymentFlag = true
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        businessId: this.deliveryData.businessId,
        businessName: this.businessName,
        postcd: this.deliveryData.postcd,
        state: this.deliveryData.state,
        city: this.deliveryData.city,
        street: this.deliveryData.street,
        building: this.building,
        userLastName: this.deliveryData.userLastName,
        userFirstName: this.deliveryData.userFirstName,
        userLastNameKana: this.deliveryData.userLastNameKana,
        userFirstNameKana: this.deliveryData.userFirstNameKana,
        tel: this.deliveryData.tel,
        delMessage: this.deliveryData.message,
        isRegistAddress: this.deliveryData.isRegistAddress,
        selectTime: this.deliveryData.selectTime,
        deliveryDate: this.getDeliveryDate(),
        paymentType: this.paymentType ? Number(this.paymentType) : null,
        guestUserLastName: this.userData.userLastName,
        guestUserFirstName: this.userData.userFirstName,
        guestUserLastNameKana: this.userData.userLastNameKana,
        guestUserFirstNameKana: this.userData.userFirstNameKana,
        guestCorpName: this.userData.corpName,
        guestPostCd: this.userData.postcd,
        guestState: this.userData.state,
        guestCity: this.userData.city,
        guestStreet: this.userData.street,
        guestTel: this.userData.tel,
        guestEmail: this.userData.email,
        guestInviteCode: this.userData.invitecode,
        guestInfoSrc: this.userData.infosrc,
        officeName: (this.orderForm.person && this.orderForm.person.cofficeName) ? this.orderForm.person.cofficeName : undefined,
        personId: (this.orderForm.person && this.orderForm.person.cuserId) ? this.orderForm.person.cuserId : undefined,
        personUserFirstName: (this.orderForm.person && this.orderForm.person.userData.cuserFirstName) ? this.orderForm.person.userData.cuserFirstName : undefined,
        personUserLastName: (this.orderForm.person && this.orderForm.person.userData.cuserLastName) ? this.orderForm.person.userData.cuserLastName : undefined
      }
      // 組設関連の追加パラメータ
      if (this.orderForm.workFlag) {
        payload.structPostcd = this.structData.postcd
        payload.structState = this.structData.state
        payload.structCity = this.structData.city
        payload.structStreet = this.structData.street
        payload.structLastName = this.structData.userLastName
        payload.structFirstName = this.structData.userFirstName
        payload.structLastNameKana = this.structData.userLastNameKana
        payload.structFirstNameKana = this.structData.userFirstNameKana
        payload.structTel = this.structData.tel
        payload.structHomeType = this.structData.homeType
        payload.structParkingSpace = this.structData.parkingSpace
        payload.structMessage = this.structData.message
        payload.btPref1 = this.structData.desiredDate1st
        payload.btPref2 = this.structData.desiredDate2nd
        payload.btPref3 = this.structData.desiredDate3rd
      }

      axios.post(DC_URL.ORDER + '/redirect-payment-site', payload)
        .then(response => {
          if (response.data.errorMessage) {
            App.showModal({
              messages: [response.data.errorMessage]
            })
            this.$refs.loadingModalRef.showModal(false)
          } else {
            const { redirectUrl, corpId, userId, orderNo } = response.data.data
            if (redirectUrl) {
              // フォームを動的に作成して POST リクエストを送信
              const form = document.createElement('form')
              form.method = 'POST'
              form.action = redirectUrl
              form.setAttribute('accept-charset', 'UTF-8')

              // パラメータをフォームに追加
              const corpIdInput = document.createElement('input')
              corpIdInput.type = 'hidden'
              corpIdInput.name = 'corpId'
              corpIdInput.value = corpId

              const userIdInput = document.createElement('input')
              userIdInput.type = 'hidden'
              userIdInput.name = 'orderNo'
              userIdInput.value = orderNo

              const orderNoInput = document.createElement('input')
              orderNoInput.type = 'hidden'
              orderNoInput.name = 'userId'
              orderNoInput.value = userId

              form.appendChild(corpIdInput)
              form.appendChild(userIdInput)
              form.appendChild(orderNoInput)

              document.body.appendChild(form)
              form.submit()
            } else {
              this.$router.push({
                name: 'OrderComplate'
              })
            }
          }
        }).catch(error => {
          // this.validateErrorMessages = {}
          // Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          // this.$router.push('/mmstyle/error')
          App.showModal({
            messages: ['アクセスが集中しており、通信に失敗いたしました。恐れ入りますが、もう一度お試しください。'],
            messageType: 'error',
            onOk: () => {
            }
          })
          console.log(error)
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
          this.paymentFlag = false
        })
    },
    fetchData: function () {
      this.topForm = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      this.orderForm = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      this.deliveryData = App.getLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      this.structData = App.getLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
    },
    getViewDate: function (date) {
      return FormUtil.getViewDate(date)
    },
    getViewTime: function () {
      if (this.deliveryData.selectTime === 1) {
        return '午前中(8:00～12:00)'
      } else if (this.deliveryData.selectTime === 2) {
        return '午後(12:00～15:00)'
      } else if (this.deliveryData.selectTime === 3) {
        return '10:00～12:00'
      } else if (this.deliveryData.selectTime === 4) {
        return '12:00～14:00'
      } else if (this.deliveryData.selectTime === 5) {
        return '14:00～16:00'
      } else if (this.deliveryData.selectTime === 6) {
        return '16:00～18:00'
      } else if (this.deliveryData.selectTime === 7) {
        return '18:00～20:00'
      }
      return ''
    },
    onShowEstimateModal: function (estimateData) {
      this.$refs.loadingModalRef.showModal(true)
      // ダイアログ表示
      let modalData = {
        onOk: () => {
          document.body.style.overflow = 'scroll'
        },
        showSuccess: () => {
          this.$refs.loadingModalRef.showModal(false)
          document.body.style.overflow = 'hidden'
        },
        fileName: estimateData.fileName,
        titleDoor: estimateData.titleDoor,
        colorDoor: estimateData.colorDoor,
        titleCabine: estimateData.titleCabine,
        colorCabine: estimateData.colorCabine,
        titleCounter: estimateData.titleCounter,
        colorCounter: estimateData.colorCounter,
        priceData: estimateData.priceData,
        targetPlan: estimateData.targetPlan,
        spaceJoincd: estimateData.spaceJoincd,
        dispOrderButton: false,
        dcProductCount: estimateData.dcProductCount,
        isCalcDelivery: true,
        isDrawing: estimateData.isDrawing,
        makerData: estimateData.makerData,
        isProductData: true,
        isNetPrice: estimateData.isNetPrice
      }
      AppEc.showEstimateModal(modalData)
    },
    getDeliveryDate: function () {
      if (!this.orderForm.workFlag || !this.orderForm.isCarryIn) {
        return this.deliveryData.deliveryDate
      }
      let deliDate = this.structData.desiredDate1st
      if (moment(deliDate).isAfter(this.structData.desiredDate2nd)) {
        deliDate = this.structData.desiredDate2nd
      }
      if (moment(deliDate).isAfter(this.structData.desiredDate3rd)) {
        deliDate = this.structData.desiredDate3rd
      }
      return moment(deliDate).add(-3, 'days').format('YYYY-MM-DD')
    },
    formatPrice: function (price) {
      return FormUtil.formatPrice(price)
    }
  },
  watch: {
  },
  mounted () {
    this.contentNo = 0
  },
  created () {
    this.fetchData()
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    if (!this.orderForm || Object.keys(this.orderForm) <= 0) {
      let pageList = App.getLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
      if (Object.keys(pageList).length > 0) {
        this.$router.go(-pageList.length)
        this.isViewer = false
      } else {
        this.$router.push({
          name: 'DcError'
        })
      }
    }
    this.paymentType = App.getLocalStorage(DC_STORAGE_KEY.PAYMENT_TYPE)
    this.$store.dispatch('loadCartData', {reload: true})
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>
<style src="../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcOrderConfirm.vue